import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from 'context/AuthContext';
import { ROUTES } from 'config/routes';

const GuestRoute: React.FC = () => {
  const { isAuthenticated } = useAuthContext();
  if (isAuthenticated) {
    return <Navigate to={ROUTES.HOME} replace />;
  }
  return <Outlet />;
};

export default GuestRoute;
